<template>
  <div class="problem-lside">
    <h3 v-if="infoId">资讯</h3>
    <h3 v-else>帮助中心</h3>
    <ul v-if="!infoId">
      <li v-for="(item, index) in otherList" :key="index">
        <a class="nli" @click="toggleList(index)">
          {{ item.type }}<b :class="['arrow', { active: activeIndex === index }]"></b>
        </a>
        <ul class="ulson" :style="{ display: activeIndex === index ? 'block' : 'none' }">
          <li v-for="(other, i) in item.informationList" :key="i">
            <a @click="$emit('select', other)">{{ other.title }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'InformationSidebar',
  props: {
    infoId: {
      type: String,
      default: ''
    },
    otherList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  methods: {
    toggleList(index) {
      this.activeIndex = this.activeIndex === index ? -1 : index
    }
  }
}
</script>

<style scoped>
.problem-lside {
  width: 200px;
  padding-right: 20px;
}
.nli {
  display: block;
  padding: 10px;
  cursor: pointer;
  position: relative;
}
.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  margin-left: 5px;
  transition: transform 0.2s;
}
.arrow.active {
  transform: rotate(180deg);
}
.ulson {
  padding-left: 15px;
}
.ulson li a {
  display: block;
  padding: 8px 10px;
  cursor: pointer;
}
</style>